import type { KeyPrefix } from 'i18next';
import { useTranslation } from 'react-i18next';

export function useErrorTranslations<TKeyPrefix extends KeyPrefix<'errors'>>(
  type?: TKeyPrefix,
) {
  return useTranslation<'errors', TKeyPrefix>('errors', { keyPrefix: type });
}
